<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Stats</span></h4>
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" :class="{ 'loading-mask': loading }">
                    <button @click="downloadCsv" class="btn btn-primary pull-right" style="margin: 10px">Download
                        CSV</button>
                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh list</button>
                    <div style="float:left; margin-top: 10px">
                        <datetime type="date" :input-class="'form-control'" :placeholder="'Choose `from` date'"
                            style="margin-left: 20px; float:left; width:200px" v-model="from"></datetime>
                        <datetime type="date" :input-class="'form-control'" :placeholder="'Choose `to` date'"
                            style="margin-left: 20px; float:left; width:200px" v-model="to"></datetime>
                        <button @click="load" class="btn btn-primary pull-right" :class="{ disabled: count > 10000 }"
                            style="margin: 10px">Load</button>
                    </div>
                    <table class="table table-striped table-xs" style="min-height: 100px">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Account</th>
                                <th>Date</th>
                                <th>Emails sent</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r, k in rows">
                                <td style="width:10px">{{ k + 1 }}</td>
                                <td>{{ r.account[0].name }}</td>
                                <td>{{ r._id.date }}</td>
                                <td>{{ r.count }}</td>
                                <td>
                                    <button @click="remove($event, r._id)" class="btn btn-sm btn-danger">Remove</button>
                                </td>
                            </tr>
                            <h2 v-if="rows.length === 0"> </h2>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
let queryDebounce
import moment from 'moment'
import EventBus from '@/event_bus'
export default {
    data() {
        return {
            showUpload: false,

            from: moment().subtract(14, 'day').toISOString(),
            to: moment().toISOString(),

            rows: [],
            loading: true,
            adding: false,
            limit: 25,
            offset: 0,
            count: 0,
            query: null
        }
    },
    watch: {
        '$route.params.type'() {
            this.load()
        },
        from() {
            this.load()
        },
        to() {
            this.load()
        },
        query() {

            if (queryDebounce) {
                clearTimeout(queryDebounce)
            }

            queryDebounce = setTimeout(() => {
                this.offset = 0
                this.load()
            }, 500)
        },
    },
    computed: {
        pages() {
            if (this.count <= this.limit) {
                return 1
            }

            return Math.ceil(this.count / this.limit)
        },
        page() {
            if (this.offset === 0) {
                return 1
            }
            return (this.offset / this.limit) + 1 || 1
        },
    },
    methods: {
        downloadCsv() {
            this.$confirm({ message: 'Confirm CSV export' }).then(() => {

                let u = this.$api.getUrl() + 'stats/aggregate?csv=1&from=' + moment(this.from).toDate().getTime() + '&to=' + moment(this.to).toDate().getTime()

                window.open(u)
                this.$notify.addWarning('Generating CSV please wait...')
            })
        },
        prevPage() {
            this.offset -= 25
            this.load()
        },
        nextPage() {
            this.offset += 25
            this.load()

        },
        load() {
            this.loading = true
            this.$api.getReq(`stats/aggregate`, {
                from: moment(this.from).toDate().getTime(),
                to: moment(this.to).toDate().getTime(),
            }).then(res => {
                this.rows = res.body.data
                this.count = res.body.data.length
                this.loading = false
            })
        }
    },
    destroyed() { },
    mounted() {
        this.load()
    }
}
</script>
<style>
.avsquare {
    width: 7px;
    height: 100%;
    float: left;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, .1);
}

.avsquare:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.avsquare:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

tbody .btn {
    padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/Stats.vue